import logoImage from './../../images/crowcloud.png';

export default class SignupController {

	static get $inject(){
		return [
			'$state', '$stateParams',
			'AlertsService','AuthService'
		];
	}

	constructor($state, $stateParams,
	            AlertsService, AuthService){

		this._$state = $state;
		this._AuthService = AuthService;

		this._AlertsService = AlertsService;
		this._AlertsService.add = this._AlertsService.add.bind(this._AlertsService);
		
		this.item = { userCode: 1234, mac: '', remoteAccessPassword: '' };
	}


	// --- VM Helpers -----------------

	submit(){
		this._AuthService.validate(this.item)
			.then((r)=>{
				this._$state.go('^.createAccount', { accessKey: r.data.accessKey });
			})
			.catch(this._AlertsService.add);
	}

	get logoImage(){
		return logoImage;
	}
}












/** WEBPACK FOOTER **
 ** ./src/guest/signup/controller.js
 **/